import { React, useState } from 'react';

const Tabs = ({ tabsData, map }) => {

    const [state, setState] = useState(tabsData[0].key);
    const showTabs = tabsData.map(tabs => <div key={tabs.id}>
        <span className={state === tabs.key ? "defaultTabsActivated" : "defaultTabs"} onClick={() => setState(tabs.key)} style={{ textAlign: "center" }}>{tabs.text}</span>
    </div>)

    let Component = () => map[state]
    return (<>
        <div className="dflex alignCenter gap20" style={{ borderBottom: "1px solid #CDD2DE" }}>
            {showTabs}
        </div>
        <Component />
    </>
    )
}

export default Tabs